module.exports = __webpack_public_path__ + "static/now-playing-c5a7473154a69dc2066b328a6194eac8.png";